import { AUTH_STATUS_APPROVE } from "constants/FormatDataContanst";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoice from "./ListInvoice";

const ListReleaseInvoice = () => {
  const [filterList, setFilterList] = useState({
    "filter[auth_status]": AUTH_STATUS_APPROVE,
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        listStatusFilter={[AUTH_STATUS_APPROVE]}
        title={"DANH SÁCH HÓA ĐƠN ĐÃ PHÁT HÀNH"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
};

export default ListReleaseInvoice;
